/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AccountNavContent_viewer$ref: FragmentReference;
export type AccountNavContent_viewer = {|
  +isMessageCenterEnabled: ?boolean,
  +$refType: AccountNavContent_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "AccountNavContent_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isMessageCenterEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "MESSAGE_CENTER",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd41778817c1cf35959f2bd8b8a5e5255';
module.exports = node;
